// src/utils/sessionUser.js
//
// Single place that knows how the logged-in user is stored in sessionStorage.
// Pages should use these functions instead of touching the keys directly.

export const SESSION_KEYS = {
  employeeId: "H7Z4L9VD2XK5JW8QRYT6",
  memberType: "K3M8X1JQ5VZ4B7PWTL9",
  universityId: "selectedUniversityId",
};

// Values are stored Base64-encoded (same format the login page already uses)
const encode = (value) => btoa(String(value ?? ""));

const decode = (key) => {
  try {
    const encoded = sessionStorage.getItem(key);
    return encoded ? atob(encoded) : null;
  } catch (error) {
    console.error("Could not read session value:", error);
    return null;
  }
};

// Call this after a successful login
export const setSessionUser = ({ employee_id, member_type }) => {
  sessionStorage.setItem(SESSION_KEYS.employeeId, encode(employee_id));
  sessionStorage.setItem(SESSION_KEYS.memberType, encode(member_type));
};

export const getSessionEmployeeId = () => decode(SESSION_KEYS.employeeId);

export const getSessionMemberType = () => decode(SESSION_KEYS.memberType);

// Call this on logout
export const clearSessionUser = () => {
  sessionStorage.removeItem(SESSION_KEYS.employeeId);
  sessionStorage.removeItem(SESSION_KEYS.memberType);
};

// Stored as plain text (not Base64), so no decoding here
export const getSessionUniversityId = () => {
  try {
    return sessionStorage.getItem(SESSION_KEYS.universityId) || null;
  } catch (error) {
    console.error("Could not read selected university:", error);
    return null;
  }
};
export const setSessionUniversityId = (id) => {
  sessionStorage.setItem(SESSION_KEYS.universityId, String(id));
  // Tell any open page that the selected university changed
  window.dispatchEvent(new Event("universityChanged"));
};
// Adds the header-selected university_id to any request payload
export const withUniversity = (payload = {}) => ({
  ...payload,
  university_id: getSessionUniversityId(),
});